import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { Reveal, RichText } from "@/components";
import { KNIT_PIPELINE, KNIT_PIPELINE_HEAD, KNIT_PIPELINE_LABEL } from "@/content";

export const KnittingPipeline = () => (
  <Box
    as="section"
    id="loop"
    className="print-flat"
    bg="surface.dark"
    color="ink.light"
    borderRadius="lg"
    mx="pad"
    px="pad"
    py="clamp(56px, 7vw, 112px)"
    mb="sec"
  >
    <Box maxW="1180px" mx="auto">
      <Grid gap="18px" mb="head">
        <Text variant="eyebrowBrand" color="brand.500">
          {KNIT_PIPELINE_HEAD.eyebrow}
        </Text>
        <Heading as="h2" variant="section" color="ink.light" maxW="18ch">
          {KNIT_PIPELINE_HEAD.title}
        </Heading>
        <Text variant="lede" color="ink.light2" maxW="52ch">
          <RichText nodes={KNIT_PIPELINE_HEAD.lede} />
        </Text>
      </Grid>

      <Grid
        as="ol"
        aria-label={KNIT_PIPELINE_LABEL}
        templateColumns={{ base: "1fr", md: "repeat(2, minmax(0, 1fr))", "2xl": "repeat(4, minmax(0, 1fr))" }}
        gap="clamp(28px, 3vw, 40px)"
      >
        {KNIT_PIPELINE.map((step, index) => (
          <Reveal
            as="li"
            key={step.id}
            index={index}
            display="grid"
            gap="12px"
            alignContent="start"
            pt="20px"
            borderTop="1px solid"
            borderColor="line.glassBorder"
          >
            <Text fontSize="small" color="brand.500" sx={{ fontVariantNumeric: "tabular-nums" }}>
              {step.index}
            </Text>
            <Heading as="h3" variant="card" color="ink.light">
              {step.title}
            </Heading>
            <Text
              className="print-muted"
              fontSize="small"
              lineHeight={1.45}
              color="ink.light2"
              sx={{ textWrap: "pretty" }}
            >
              {step.body}
            </Text>
          </Reveal>
        ))}
      </Grid>
    </Box>
  </Box>
);
